import { Component, HostListener, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { AuthService } from './core/auth.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit{
  title = 'Katamix';
  private isMobileView: boolean;
  public innerWidth: any;

  constructor(
    public authService: AuthService,
    private router: Router,
    private titleService: Title,
  ) {
    titleService.setTitle(this.title);
  }
  ngOnInit(): void {
    if (window.innerWidth > 800) {
      this.isMobileView = false;
    } else {
      this.isMobileView = true;
    };
  }

  public getIsMobileView(): boolean {
    return this.isMobileView;
  }

  logOut(): void {
    this.authService.logout();
    this.router.navigate(['/login']);
  }

}
